import React, { useState, useEffect } from 'react';
import { createNotification, updateNotification } from '../api/api';
import '../index.css';
import './UserForm.css'; // Reuse UserForm CSS
import Form from './common/Form';
import Input from './common/Input';
import Select from './common/Select';
import Button from './common/Button';
import Error from './common/Error';

const NotificationForm = ({ notification, onClose, onNotificationUpdated, onNotificationCreated, users }) => {
    const [formData, setFormData] = useState({
        title: '',
        send_date: '',
        details: '',
        type: 'appointment',
        user_email: '',
        viewed: false,
    });
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");
    const validNotificationTypes = ["appointment", "reminder"];

    useEffect(() => {
        if (notification) {
            setIsEditing(true);
            setFormData({
                title: notification.title,
                send_date: notification.send_date,
                details: notification.details,
                type: notification.type,
                user_email: notification.user_email,
                viewed: notification.viewed,
            });
        }
    }, [notification]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        try {
            if (isEditing) {
                const updatedNotification = await updateNotification(notification.id, formData);
                if (updatedNotification) {
                    onNotificationUpdated(updatedNotification);
                    setMessage("Notificación actualizada");
                }
            } else {
                const newNotification = await createNotification(formData);
                onNotificationCreated(newNotification);
                setMessage("Notificación creada");
            }
            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (err) {
            setError(err.message || 'Error al procesar la notificación');
        }
    };

    return (
        <Form className='form-user' onSubmit={handleSubmit}>
            {message && <div className='container-message'>{message}</div>}
            {error && <Error error={error} />}
            <Input type="text" id="title" name="title" value={formData.title} onChange={handleChange} label="Título" required />
            <Input type="datetime-local" id="send_date" name="send_date" value={formData.send_date} onChange={handleChange} label="Fecha de Envío" required />
            <Input type="text" id="details" name="details" value={formData.details} onChange={handleChange} label="Detalles" required />
            <Select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
                label="Tipo de Notificación"
                required
                options={validNotificationTypes.map(type => ({ value: type, label: type }))}
            />
            <Select
                id="user_email"
                name="user_email"
                value={formData.user_email}
                onChange={handleChange}
                label="Email del Usuario"
                required
                options={users.map(user => ({ value: user.email, label: user.email }))}
            />

            <Button type="submit">{isEditing ? 'Actualizar' : 'Crear'}</Button>
            <Button type='button' onClick={onClose}>Cancelar</Button>
        </Form>
    );
};

export default NotificationForm;
